import { useTranslation } from 'react-i18next'

type SpinnerSize = 'sm' | 'md' | 'lg'

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-3.5 w-3.5 border-[1.5px]',
  md: 'h-4 w-4 border-2',
  lg: 'h-5 w-5 border-2',
}

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const { t } = useTranslation()

  return (
    <span
      role="status"
      aria-label={t('common.loading_label')}
      className={[
        'animate-spin rounded-full border-current border-r-transparent',
        sizeClasses[size],
        className,
      ].join(' ')}
    />
  )
}
